export default [
    { value: 'binance', label: 'Binance' },
    { value: 'hollaex', label: 'HollaEx' },
    { value: 'custom', label: 'Custom' },
    { value: 'Custom Script', label: 'Custom Script' },
    // { value: "uniswap", label: "Uniswap" },
    // { value: "stex", label: "Stex" },
    { value: 'aax', label: 'AAX' },
    { value: 'ascendex', label: 'AscendEX' },
    { value: 'bequant', label: 'Bequant' },
    { value: 'binancecoinm', label: 'Binance COIN - M' },
    { value: 'binanceus', label: 'Binance US' },
    { value: 'bitcoincom', label: 'FMFW.io' },
    { value: 'bitfinex', label: 'Bitfinex' },
    { value: 'bitmart', label: 'BitMart' },
    { value: 'bitmex', label: 'BitMEX' },
    { value: 'bybit', label: 'Bybit' },
    { value: 'bitopro', label: 'BitoPro' },
    { value: 'bitstamp', label: 'Bitstamp' },
    { value: 'bittrex', label: 'Bittrex' },
    { value: 'bitvavo', label: 'Bitvavo' },
    { value: 'coinbaseprime', label: 'Coinbase Prime' },
    { value: 'coinbasepro', label: 'Coinbase Pro' },
    { value: 'coinflex', label: 'CoinFLEX' },
    { value: 'currencycom', label: 'Currency.com' },
    { value: 'flowbtc', label: 'flowBTC' },
    { value: 'fmfwio', label: 'FMFW.io' },
    { value: 'ftx', label: 'FTX' },
    { value: 'ftxus', label: 'FTX US' },
    { value: 'gateio', label: 'Gate.io' },
    { value: 'hitbtc', label: 'HitBTC' },
    { value: 'hitbtc3', label: 'HitBTC3' },
    { value: 'huobi', label: 'Huobi' },
    { value: 'huobijp', label: 'Huobi Japan' },
    { value: 'idex', label: 'IDEX' },
    { value: 'kraken', label: 'Kraken' },
    { value: 'kucoin', label: 'KuCoin' },
    { value: 'mexc', label: 'MEXC Global' },
    { value: 'ndax', label: 'NDAX' },
    { value: 'okcoin', label: 'OKCoin' },
    { value: 'okx', label: 'OKX' },
    { value: 'phemex', label: 'Phemex' },
    { value: 'poloniex', label: 'Poloniex' },
    { value: 'ripio', label: 'Ripio' },
    { value: 'upbit', label: 'Upbit' },
    { value: 'zb', label: 'ZB' },
    { value: 'zipmex', label: 'Zipmex' },
];


